import { render, staticRenderFns } from "./HisTextItemComponent.vue?vue&type=template&id=7264a4bb&scoped=true&"
import script from "./HisTextItemComponent.vue?vue&type=script&lang=ts&"
export * from "./HisTextItemComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7264a4bb",
  null
  
)

export default component.exports